import { ApolloError } from '@apollo/client';
import { type GraphQLErrors } from '@apollo/client/errors';

/**
 * Почему-то когда Apollo возвращает результат и тип у errors: GraphQLErrors, то это не всегда правда
 * и он может быть ApolloError. Эта утилита приводит к единому виду
 */
export function getGraphqlErrors(error: ApolloError | GraphQLErrors | null | undefined): readonly Error[] {
  return error instanceof ApolloError ? [error] : (error ?? []);
}
